<template>
  <div>
    <div class="kpi" :style="{background:kpiBackgrounds.bjzs_color}">
      <div class="kpi-rule" v-if="kpiBackgrounds.rule_text && kpiBackgrounds.rule_link" :style="{background:kpiBackgrounds.rule_color}" @click='jump(kpiBackgrounds.rule_link)'>
        {{kpiBackgrounds.rule_text}}<img src="https://mktv-in-cdn.mockuai.com/16279629728651833.png" alt="">
      </div>
      <div v-if="activeStatus ==100" class="kpi-title" :style="{color:kpiBackgrounds.bjfzs_color}">
        <div class="kpi-title-line"></div>
        <div>{{kpiBackgrounds.yr_header_text || '老铁冲冲冲大奖等你拿'}}</div>
        <div class="kpi-title-line"></div>
      </div>
      <div v-else-if="activeStatus ==200" class="kpi-title" :style="{color:kpiBackgrounds.bjfzs_color}">
        <div class="kpi-title-line"></div>
        <div>恭喜你已冲到第 {{kpiData.current_level}} 关</div>
        <div class="kpi-title-line"></div>
      </div>
      <div v-else-if="activeStatus ==300" class="kpi-title" :style="{color:kpiBackgrounds.bjfzs_color}">
        <div class="kpi-title-line"></div>
        <div>{{kpiBackgrounds.yr_header_text || '老铁冲冲冲大奖等你拿'}}</div>
        <div class="kpi-title-line"></div>
      </div>
      <div class="kpi-countdown">
        <div v-if="activeStatus !=300" class="kpi-countdown-time">
          <span :style="{color:kpiBackgrounds.bjfzs_color}">{{['距开始', '距结束', '已结束'][activeStatus * 1 / 100 - 1]}}</span>
          <div class="kpi-countdown-flex" v-if="remainDays">
            <div class="kpi-countdown-text-time" :style="{background:kpiBackgrounds.bjfzs_color,color:kpiBackgrounds.bjzs_color}">
              {{ formatMinNumber(remainDays) || 0 }}
            </div>
            <span :style="{color:kpiBackgrounds.bjfzs_color}">天</span>
          </div>
          <div class="kpi-countdown-flex" v-if="remainDays || remainHours">
            <div class="kpi-countdown-text-time" :style="{background:kpiBackgrounds.bjfzs_color,color:kpiBackgrounds.bjzs_color}">
              {{ formatMinNumber(remainHours) || 0 }}
            </div>
            <span :style="{color:kpiBackgrounds.bjfzs_color}">时</span>
          </div>
          <div
            class="kpi-countdown-flex"
            v-if="remainDays || remainHours || remainMinute"
          >
            <div class="kpi-countdown-text-time" :style="{background:kpiBackgrounds.bjfzs_color,color:kpiBackgrounds.bjzs_color}">
              {{ formatMinNumber(remainMinute) || 0 }}
            </div>
            <span :style="{color:kpiBackgrounds.bjfzs_color}">分</span>
          </div>
          <div class="kpi-countdown-flex" v-if="!remainDays">
            <div class="kpi-countdown-text-time" :style="{background:kpiBackgrounds.bjfzs_color,color:kpiBackgrounds.bjzs_color}">
              {{ formatMinNumber(remainSecond) || 0 }}
            </div>
            <span :style="{color:kpiBackgrounds.bjfzs_color}">秒</span>
          </div>
        </div>
        <div v-else class="kpi-countdown-time" :style="{color:kpiBackgrounds.bjfzs_color}">
          活动已结束
        </div>
      </div>
      <div class="kpi-content">
        <div class="overflow">
          <div class="overflow-box">
            <div
              class="overflow-arrow overflow-arrow-left"
              @click="overflowLeft"
            >
              <img
                src="https://mktv-in-cdn.mockuai.com/16036808149576754.png"
                alt=""
              />
            </div>
            <div class="overflow-right" ref="overbox">
              <div
                class="line"
                :style="{ width: `${dymWidth}px`, left: '0px', background: kpiBackgrounds.jdtbj_color}"
              >
                <div v-if="kpiProgress && (kpiProgress.length == kpiData.current_level)" class="line-colorful" :style="{ width: `${dymWidth}px`,background: kpiBackgrounds.jdt_color}"></div>
                <div v-else="kpiProgress" class="line-colorful" :style="{ width: `${dymColorWidth}px`,background: kpiBackgrounds.jdt_color}"></div>
              </div>
              <div
                v-if="
                        kpiRule &&
                          kpiRule.award_rules &&
                          kpiRule.award_rules.length
                      "
                class="item"
                :ref="`item-${index}`"
                v-for="(prize, index) in kpiRule.award_rules"
                :key="index"
                :class="prize.active?'active':''"
              >
                <div class="item-level">
                  <img
                    v-show="!prize.active"
                    src="https://mktv-in-cdn.mockuai.com/16262640285749331.png"
                    alt=""
                  />
                  <img
                    v-show="prize.active"
                    src="https://mktv-in-cdn.mockuai.com/16262640285683025.png"
                    alt=""
                  />
                </div>
                <div class="text" v-if="currency_type ==1" :style="{background:(prize.active?kpiBackgrounds.tcwabj_color:kpiBackgrounds.smwabj_color),color:(prize.active?kpiBackgrounds.tcwa_color:kpiBackgrounds.smwa_color)}">
                  奖金{{ filterNum(filterPrice(prize.award_type_value)) }}元
                </div>
                <div class="text" v-if="currency_type ==2" :style="{background:(prize.active?kpiBackgrounds.tcwabj_color:kpiBackgrounds.smwabj_color),color:(prize.active?kpiBackgrounds.tcwa_color:kpiBackgrounds.smwa_color)}">
                  奖励{{ filterNum(prize.award_type_value) }}魔筷币
                </div>

                <div class="popper-item">
                  <div class="popper-item_text" :style="{color:kpiBackgrounds.smwa_color}">
                    <p class="popper-item_text_sales">销售额</p>
                    <p style="font-weight: bold">{{ filterNum(filterPrice(prize.step_start)) }}元</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="overflow-arrow" @click="overflowRight">
              <img
                src="https://mktv-in-cdn.mockuai.com/16036808149576754.png"
                alt=""
              />
            </div>
          </div>
          <div v-if="activeStatus == 100" class="step-tips" :style="{background:kpiBackgrounds.cywabj_color}">
            {{kpiBackgrounds.yr_footer_text || '开播达门槛，直接领大奖！'}}
          </div>
          <div v-else-if="activeStatus == 200 || activeStatus == 300" class="step-tips" :style="{background:kpiBackgrounds.cywabj_color}">
            当前销售额：<span :style="{color:kpiBackgrounds.tcwa_color}">{{filterNum(filterPrice(kpiData.current_gmv))}}元</span><span v-if="activeStatus != 300"><span> | </span>距下一阶段奖励还差<span :style="{color:kpiBackgrounds.tcwa_color}">{{filterNum(filterPrice(kpiData.next_gap_gmv))}}元</span></span>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {redirectURL} from '@/js/jump';
export default {
  props: [
    'kpiIds',
    'kpiBackgrounds'
  ],
  data() {
    return {
      activeStatus: 100,
      kpiProgress: [], // 任务进度
      kpiData: {}, // 任务总数据
      kpiRule: {
        award_rules: [],
      },
      remainDays: 0,
      remainHours: 0,
      remainMinute: 0,
      remainSecond: 0,
      remainTimer: null, // 目标倒计时
      dymWidth: 0, // 目标整体进度
      dymColorWidth: 0, // 目标进行进度
      step: 0,
      currency_type: '',
    }
  },
  watch: {
    kpiIds: function (newKpiIds, oldKpiIds) {
      this.userKpi();
    }
  },
  computed: {},
  created() {
    this.userKpi();
  },
  methods: {
    jump(item) {
      if (this.isEditorStatus || !item) {
        return;
      }
      redirectURL(item.toString());
    },
    //进度
    kpiProgressGet() {
      lib.api.get({
        api: 'ec/b/operation/activity/user-kpi-progress/get',
        data: {
          award_rule_id: this.kpiIds.id,
          activity_id: this.kpiIds.activity_id
        },
        success: (res) => {
          if (res.data && res.data.countdown) {
            this.initLimitedDiscount(res.data.countdown);
          }
          this.activeStatus = res.data.activity_state;
          this.kpiData = res.data;
          if(res.data && res.data.progress && res.data.progress.length){
            this.kpiProgress = res.data.progress;
            res.data.progress.forEach((item,index)=>{
              if(item.completion_progress == 10000){
                this.kpiRule.award_rules[index].active = true;
              }
            })
          }
          // 计算当前任务进度
          let currentKpiWidth = 0;
          if(this.kpiProgress[this.kpiData.current_level] && this.kpiProgress[this.kpiData.current_level].completion_progress){
            currentKpiWidth = this.kpiProgress[this.kpiData.current_level].completion_progress/10000*((this.dymWidth-48)/this.kpiProgress.length)
          }
          if(this.kpiData.current_level){
            this.dymColorWidth = (this.dymWidth/this.kpiProgress.length) * this.kpiData.current_level - 40 + currentKpiWidth;
          }else{
            if(this.kpiProgress[this.kpiData.current_level] && this.kpiProgress[this.kpiData.current_level].completion_progress){
              this.dymColorWidth = this.kpiProgress[this.kpiData.current_level].completion_progress/10000*68;
            }
          }

        },
        error: (err) => {
        },
      });
    },
    // 用户kpi获取
    userKpi() {
      if(!this.kpiIds && !this.kpiIds.id){
        return;
      }
      lib.api.post({
        api: 'ec/b/operation/activity/rule/kpi/get',
        data: {
          activity_award_rule_id: this.kpiIds.id
        },
        success: (res) => {
          this.currency_type = res.data.currency_type;
          let data = JSON.parse(res.data.extra);
          this.kpiRule = data;
          this.kpiProgressGet();
          this.$nextTick(() => {
            this.dymWidth = this.$refs.overbox.scrollWidth;
          });
        },
        error: (err) => {
        },
      });
    },
    /**
     * 初始化时间
     * @param {number} remainTime 结束倒计时
     */
    initLimitedDiscount(remainTime) {
      this.remainDays = Math.floor(remainTime / 1000 / 60 / 60 / 24);
      this.remainHours = Math.floor((remainTime / 1000 / 60 / 60) % 24);
      this.remainMinute =
        Math.floor(remainTime / 1000 / 60) -
        (this.remainHours + this.remainDays * 24) * 60;
      this.remainSecond =
        Math.floor(remainTime / 1000) -
        (this.remainHours + this.remainDays * 24) * 60 * 60 -
        this.remainMinute * 60;
      this.startRemainTimer();
    },

    /**
     * 开始倒计时
     * @param {Number} num 数字
     */
    startRemainTimer() {
      this.remainTimer = setInterval(() => {
        if (this.remainSecond !== 0) {
          this.remainSecond -= 1;
        } else if (this.remainMinute !== 0) {
          this.remainMinute -= 1;
          this.remainSecond = 59;
        } else if (this.remainHours !== 0) {
          this.remainHours -= 1;
          this.remainMinute = 59;
          this.remainSecond = 59;
        } else if (this.remainDays !== 0) {
          this.remainDays -= 1;
          this.remainHours = 23;
          this.remainMinute = 59;
          this.remainSecond = 59;
        } else {
          this._destroyRemainTimer();
          this.kpiProgressGet();
        }
      }, 1000);
    },
    overflowLeft() {
      if (this.step <= 0) {
        return;
      }
      this.step -= 1;
      $(".overflow-right").scrollLeft((this.step * this.dymWidth) / this.kpiProgress.length);
    },
    overflowRight() {
      if (this.step >= this.kpiProgress.length-3) {
        return;
      }
      this.step += 1;
      $(".overflow-right").scrollLeft((this.step * this.dymWidth) / this.kpiProgress.length);
    },
    formatMinNumber(num) {
      return num < 10 ? `0${num}` : `${num}`;
    },
    filterPrice(data, i = 2, isFix = true) {
      if (data && !isNaN(data)) {
        let yuan = Number(data / Math.pow(10, i));
        let fixed0 = yuan.toFixed(0);
        let fixed1 = yuan.toFixed(1);
        let fixed2 = yuan.toFixed(2);
        if (!isFix) {
          return yuan;
        }
        if (
          Number(fixed0) == Number(fixed1) &&
          Number(fixed1) == Number(fixed2)
        ) {
          return fixed0;
        } else if (
          Number(fixed0) != Number(fixed1) &&
          Number(fixed1) == Number(fixed2)
        ) {
          return fixed1;
        } else {
          return fixed2;
        }
      } else {
        return 0;
      }
    },
    filterNum(num, tag = '万') {
      if (isNaN(num)) {
        return '';
      }
      if (num < 10000) {
        return num;
      } else {
        let result = Math.floor(num / 100) / 100 + tag;
        return result;
      }
    },
    /**
     * 清除定时器
     */
    _destroyRemainTimer() {
      if (this.remainTimer) {
        clearInterval(this.remainTimer);
        this.remainTimer = null;
      }
      if (this.countTimer) {
        clearTimeout(this.countTimer);
        this.countTimer = null;
      }
      if (this.showTimeLineSetTimeOut) {
        clearTimeout(this.showTimeLineSetTimeOut);
        this.showTimeLineSetTimeOut = null;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.kpi {
  background: #0F3DAE;
  border-radius: 12px;
  margin: 10px;
  &-rule{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 10px;
    top: 10px;
    width: 39px;
    height: 20px;
    border-radius: 100px 1px 1px 100px;
    color: #fff;
    line-height: 20px;
    font-size: 10px;
    text-align: center;
    
    img{
      margin-left: 3px;
      width: 4px;
      height: 6px;
    }
  }

  &-title {
    height: 22px;
    line-height: 22px;
    font-size: 15px;
    padding: 10px 0 2px;
    display: flex;
    justify-content: center;
    align-items: center;

    &-line {
      height: 2px;
      width: 8px;
      border-radius: 1px;
      background: #fff;color:#0F3DAE;
      margin: 0 10px;
    }
  }

  &-countdown {
    padding: 4px 0 12px;
    font-size: 14px;
    &-time {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-flex {
      display: flex;
      align-items: center;
    }

    &-text {
      display: flex;
      color: #fff;

      &-time {
        text-align: center;
        font-size: 12px;
        font-weight: bold;
        width: 20px;
        height: 20px;
        line-height: 20px;
        background: #1342b2;
        border-radius: 4px;
        margin: 0 5px;
      }
    }
  }

  &-content {
    padding-bottom: 10px;
  }

  .overflow {
    background: #fff;color:#0F3DAE;
    border-radius: 10px;
    position: relative;
    margin: 0 10px;
    padding-bottom: 10px;

    &-box {
      padding: 10px 0px 12px;
      display: flex;
      overflow: hidden;

      .overflow-right {
        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }

        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        flex: 1;
        position: relative;
        display: flex;
        align-items: flex-end;
        overflow-x: auto;
        overflow-y: hidden;
        padding-left: 18px;
        padding-bottom: 1px;
        min-height: 80px;

        .line {
          position: absolute;
          top: 50%;
          margin-top: 1px;
          height: 5px;
          background: #e6e6e6;
          border-radius: 5px;

          .line-colorful {
            border-radius: 5px;
            position: absolute;
            height: 100%;
            background: linear-gradient(270deg, #FFAB96, #FF0F47);
          }
        }
        .item {
          flex-shrink: 0;
          padding: 40px 10px 30px;
          position: relative;
          z-index: 10;
          width:48px;
          overflow: visible;
          text-align: center;
          box-sizing: content-box;
          &-level{
            //margin-top: -6px;
          }

          &.active {
            .popper-item {
              color: #800009;
            }

            .text {
              background: linear-gradient(270deg, #ffa16e, #ff0f47);
            }
          }

          & + .item {
            margin-left: 33px;
          }

          .text {
            position: absolute;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
            color: #fff;
            font-size: 11px;
            text-align: center;
            height: 24px;
            padding: 0 5px;
            min-width: 82px;
            line-height: 24px;
            background: linear-gradient(270deg, #888686, #dedada);
            border-radius: 12px;
          }

          .popper-item {
            position: absolute;
            top: 0px;
            left: 50%;
            transform: translateX(-50%);
            width: 78px;
            height: 23px;
            line-height: 23px;
            color: #4d4d4d;
            font-size: 10px;
            text-align: center;

            &_text {
              position: absolute;
              top: 0;
              width: 78px;
              font-size: 13px;
              color: #ca2746;
              line-height: 17px;
              &_sales{
                font-size: 12px;
              }
            }
          }

          img {
            width: 14.5px;
          }
        }
      }

      .overflow-arrow {
        flex-shrink: 0;
        width: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 7px;
        &-left {
          img {
            transform: rotate(180deg);
          }
        }

        img {
          width: 7px;
          height: 12px;
        }
      }
    }

    &-rule {
      text-align: center;
      color: #ca2746ff;
      padding: 5px 0 15px;
      font-size: 11px;
      height: 11px;
      line-height: 11px;

      span {
        padding-left: 15px;
        background: url("https://mktv-in-cdn.mockuai.com/16195271296389029.png") no-repeat left center;
        background-size: 12px;
        padding-right: 5px;
      }
    }
  }
}

.step-tips{
  background: #F6F6F6;
  text-align: center;
  height: 25px;
  line-height: 25px;
  margin: 0 20px;
  border-radius: 25px;
  font-size: 12px;
  color: #666;
  /*! autoprefixer: off */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  /* autoprefixer: on  */
}

</style>
